import { render } from "./SaleSharedDetailTab.vue?vue&type=template&id=0e408485"
import script from "./SaleSharedDetailTab.vue?vue&type=script&lang=js"
export * from "./SaleSharedDetailTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__